import React from "react";
import { Button, Modal } from "../../../../../components";

const VerifyModal = ({
  verifyModalOpen,
  setVerifyModalOpen,
  setViewModalOpen,
  actionsHandler,
}) => {
  return (
    <Modal
      isOpen={verifyModalOpen}
      title={"Verify"}
      titleColor={"black"}
      showCloseButton={false}
      width="max-w-2xl"
    >
      <div className="flex flex-col gap-2">
        <div>Are you sure you want to approve this document ?</div>
        <div className="flex items-center justify-center gap-4 mt-15">
          <Button
            title={"Cancel"}
            variant="outlined"
            className="!py-1"
            onClick={() => {
              (setVerifyModalOpen(false), setViewModalOpen(false));
            }}
          />
          <Button title={"Yes"} className="!py-1" onClick={()=>actionsHandler("verify")}/>
        </div>
      </div>
    </Modal>
  );
};

export default VerifyModal;
